import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { COLOR_CONTAINER_CONVERTER_TOKEN, ColorContainerConverter } from './color-container.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  COLOR_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN, ColorContainerContentTextConverter
} from './color-container-content-text/color-container-content-text.component.converter'
import {
  COLOR_CONTAINER_DOT_PLOTS_BOXES_CONVERTER_TOKEN, ColorContainerDotPlotsBoxesConverter
} from './color-container-dot-plots-boxes/color-container-dot-plots-boxes.component.converter'
import {
  COLOR_CONTAINER_DOT_PLOTS_BOX_CONVERTER_TOKEN, ColorContainerDotPlotsBoxConverter
} from './color-container-dot-plots-boxes/color-container-dot-plots-box/color-container-dot-plots-box.component.converter'
import {
  COLOR_CONTAINER_HEADLINE_CONVERTER_TOKEN, ColorContainerHeadlineConverter
} from './color-container-headline/color-container-headline.component.converter'
import {
  COLOR_CONTAINER_IMAGE_AND_CONTENT_CONVERTER_TOKEN, ColorContainerImageAndContentConverter
} from './color-container-image-and-content/color-container-image-and-content.component.converter'
import {
  COLOR_CONTAINER_IMAGE_AND_CONTENT_CONTAINER_CONVERTER_TOKEN, ColorContainerImageAndContentContainerConverter
} from './color-container-image-and-content-container/color-container-image-and-content-container.component.converter'
import {
  COLOR_CONTAINER_IMAGE_WITH_WRAPPING_CONVERTER_TOKEN, ColorContainerImageWithWrappingConverter
} from './color-container-image-with-wrapping/color-container-image-with-wrapping.component.converter'
import {
  COLOR_CONTAINER_PDF_TEASER_CONVERTER_TOKEN, ColorContainerPdfTeaserConverter
} from './color-container-pdf-teaser/color-container-pdf-teaser.component.converter'
import {
  COLOR_CONTAINER_RELATED_ITEMS_CONVERTER_TOKEN, ColorContainerRelatedItemsConverter
} from './color-container-related-items/color-container-related-items.component.converter'
import {
  COLOR_CONTAINER_RELATED_ITEM_LINK_CONVERTER_TOKEN, ColorContainerRelatedItemLinkConverter
} from './color-container-related-items/color-container-related-item-link/color-container-related-item-link.component.converter'
import {
  COLOR_CONTAINER_VIDEO_AND_CONTENT_CONVERTER_TOKEN, ColorContainerVideoAndContentConverter
} from './color-container-video-and-content/color-container-video-and-content.component.converter'
import {
  COLOR_CONTAINER_INPAGE_NAVIGATION_CONVERTER_TOKEN, ColorContainerInpageNavigationConverter
} from './color-container-navigation/color-container-inpage-navigation/color-container-inpage-navigation.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        colorContainerFeature: {
          module: () => import('./color-container.module').then((m) => m.ColorContainerModule),
          cmsComponents: ['color_container'],
        },
      },
    }),
    {
      provide: COLOR_CONTAINER_CONVERTER_TOKEN,
      useExisting: ColorContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container: COLOR_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN,
      useExisting: ColorContainerContentTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_content_text: COLOR_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_DOT_PLOTS_BOXES_CONVERTER_TOKEN,
      useExisting: ColorContainerDotPlotsBoxesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_dot_plots_boxes: COLOR_CONTAINER_DOT_PLOTS_BOXES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_DOT_PLOTS_BOX_CONVERTER_TOKEN,
      useExisting: ColorContainerDotPlotsBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_dot_plots_box: COLOR_CONTAINER_DOT_PLOTS_BOX_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_HEADLINE_CONVERTER_TOKEN,
      useExisting: ColorContainerHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_headline: COLOR_CONTAINER_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_IMAGE_AND_CONTENT_CONVERTER_TOKEN,
      useExisting: ColorContainerImageAndContentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_image_and_content: COLOR_CONTAINER_IMAGE_AND_CONTENT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_IMAGE_AND_CONTENT_CONTAINER_CONVERTER_TOKEN,
      useExisting: ColorContainerImageAndContentContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_image_and_content_container: COLOR_CONTAINER_IMAGE_AND_CONTENT_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_IMAGE_WITH_WRAPPING_CONVERTER_TOKEN,
      useExisting: ColorContainerImageWithWrappingConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_image_with_wrapping: COLOR_CONTAINER_IMAGE_WITH_WRAPPING_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_PDF_TEASER_CONVERTER_TOKEN,
      useExisting: ColorContainerPdfTeaserConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_pdf_teaser: COLOR_CONTAINER_PDF_TEASER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_RELATED_ITEMS_CONVERTER_TOKEN,
      useExisting: ColorContainerRelatedItemsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_related_items: COLOR_CONTAINER_RELATED_ITEMS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_RELATED_ITEM_LINK_CONVERTER_TOKEN,
      useExisting: ColorContainerRelatedItemLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_related_item_link: COLOR_CONTAINER_RELATED_ITEM_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_VIDEO_AND_CONTENT_CONVERTER_TOKEN,
      useExisting: ColorContainerVideoAndContentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_video_and_content: COLOR_CONTAINER_VIDEO_AND_CONTENT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: COLOR_CONTAINER_INPAGE_NAVIGATION_CONVERTER_TOKEN,
      useExisting: ColorContainerInpageNavigationConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        color_container_inpage_navigation: COLOR_CONTAINER_INPAGE_NAVIGATION_CONVERTER_TOKEN
      },
      multi: true
    },
  ],
})
export class ColorContainerFeatureModule {}
